import {Component, Inject} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

import { ErrorResponse } from '../../../../data/model/errorResponse';
import { LogEntry } from '../../../../data/model/log.entry';
import { LogEntriesDataManager } from '../../../../data/log.entries.datamanager';

@Component({
  selector: 'log-entry-detail-dialog',
  templateUrl: './detail.dialog.html',
  styleUrls: ['./detail.dialog.component.scss']
})
export class LogEntryDetailDialogComponent {
    logEntry: LogEntry;

    constructor(
        public dialogRef: MatDialogRef<LogEntryDetailDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.logEntry = data.logEntry;
        this.logEntry.request_body = this.formatJSON(this.logEntry.request_body);
        this.logEntry.response_body = this.formatJSON(this.logEntry.response_body);
    }

    formatJSON(json){
        if(!json){
            return '';
        }

        json = JSON.parse(json);

        if(typeof json === 'string'){
            json = JSON.parse(json);            
        }

        return JSON.stringify(json, undefined, 4);
    }

    closeDialogWithError(error: ErrorResponse) {
        this.dialogRef.close(error);
    }

    closeDialogSuccess(message: string) {
        this.dialogRef.close(message);
    }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/log.entries/detail/detail.dialog.component.ts